import React, { useEffect, useState } from 'react';
import { Typography, Table } from 'antd';
import Proptypes from 'prop-types';
import { downloadFileUrl, getNameUrl } from '../../utilities/Functions';
import CustomIcon from '../CustomIcon/CustomIcon';

import './index.less';

const { Title } = Typography;

const DetailDownloadModal = ({ files, onCancel }) => {
  const [items, setItems] = useState([]);

  const refactorUrl = (file) => {
    return file.map((e) => {
      return { fileName: e };
    });
  };

  useEffect(() => {
    if (files) {
      setItems(refactorUrl(files));
    }
  }, [files]);

  const columns = [
    {
      title: 'Nombre de Archivo',
      dataIndex: 'fileName',
      key: 'fileName',
      render: (fileName) => {
        if (!fileName) return null;
        const decodeString = atob(fileName);
        return (
          <div className="row-download" onClick={() => downloadFileUrl('tracking', fileName)}>
            <span>
              <CustomIcon type="download2" /> {getNameUrl(decodeString)}
            </span>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <CustomIcon className="cancel-sendEmailModal" type="cancel" onClick={() => onCancel()} />

      <div className="container-downloadModal">
        <Title className="title-downloadModal">Archivos adjuntos</Title>
        <Table
          columns={columns}
          dataSource={items}
          size="middle"
          scroll={{ y: 'calc(320px)' }}
          className="table-download"
          pagination={false}
        />
      </div>
    </>
  );
};

DetailDownloadModal.displayName = 'DetailDownloadModal';

DetailDownloadModal.defaultProps = {
  files: [],
  onCancel: () => {},
};

DetailDownloadModal.propTypes = {
  files: Proptypes.array,
  onCancel: Proptypes.func,
};

export default DetailDownloadModal;
